if (window.matchMedia('screen and (max-width: 1200px)').matches) {
    if (document.getElementsByClassName("form-section_form")[1]) {
        let right_form = document.getElementsByClassName("form-section_form")[0];
        right_form.remove()
    }
}

const input = document.getElementById("file");
const labelInput = document.getElementsByClassName("fakeInputFile")[0];

if(input && labelInput ) {

    let defaultLabel = labelInput.innerHTML;

    input.addEventListener('change', function (event) {
        let fileName = event.target.value.split(/(\\|\/)/g).pop();
        labelInput.innerHTML = fileName ? fileName : defaultLabel;
    });

}
